import { AuthConfig } from 'angular-oauth2-oidc';

const defaultConfig: AuthConfig = {
  strictDiscoveryDocumentValidation: false,
  redirectUri: window.location.origin,
  postLogoutRedirectUri: window.location.origin,
  oidc: true,
  scope: 'openid',
  responseType: 'code'
};

export const buildConfig = (options: AuthConfig): AuthConfig => ({ ...defaultConfig, ...options });
